// Recovered compiled webpack factory 76726. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "removePathPrefix", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(2018);
  function a(e, t) {
    if (!(0, n.pathHasPrefix)(e, t)) return e;
    let r = e.slice(t.length);
    return r.startsWith("/") ? r : "/" + r;
  }
}
